import withAemIntegration from "../../../withAemIntegration";
import {
  ResponsiveGrid,
  withComponentMappingContext,
} from "@adobe/aem-react-editable-components";
import loadable from "@loadable/component";
import ComponentWrapper from "../../component-wrapper";
const Component = loadable(() => import("@lexus.com/ui/dist/modules/Overlay"));

const OverlayEditConfig = {
  emptyLabel: "Overlay Module",
  isEmpty: (props) => !props?.children?.length,
};

const transformData = (props) => ({
  ...props,
  src: props?.iframeSrc,
})
export class Overlay extends ResponsiveGrid {
  render() {
    const { editorMode = false } = window;
    const {title, ...props} = this.props; // strip title from meta data since it shouldn't be used here.

    if (editorMode)
      return (
        <div>
          <ComponentWrapper>{super.childComponents}</ComponentWrapper>
          {super.placeholderComponent}
        </div>
      );

    return (
      <Component {...transformData(props)}>
        <ComponentWrapper>{super.childComponents}</ComponentWrapper>
      </Component>
    );
  }
}

const OverlayComponent = withComponentMappingContext(Overlay);
OverlayComponent.displayName = 'OverlayComponent';

export default withAemIntegration("lexus/components/overlay-component")(
  OverlayComponent,
  OverlayEditConfig
);
